import React from 'react';
import VitalsNav from './VitalsNav';
import LiveMonitor from '../livemonitor/LiveMonitor';
import './vitals.css';

export default function VitalsDashboard() {
  return (
    <div className="vitals-page">
      <VitalsNav />
      <LiveMonitor hideMissingData hideTelemetry persistAlerts />
    </div>
  );
}
